import { css } from 'linaria';

export const seedsSection = css`
  width: 100%;
  margin-bottom: 80px;

  @media (--to-desktop) {
    margin-bottom: 56px;
  }
`;

export const seedsSectionTitle = css`
  margin-bottom: 16px;

  @media (--only-mobile) {
    margin-bottom: 8px;
  }
`;

export const seedsSectionDescription = css`
  margin-bottom: 32px;
`;

export const seedSlide = css`
  && {
    width: 270px;
    margin-right: 32px;

    @media (--only-desktop) {
      width: 292px;
    }

    @media (--only-tablet) {
      width: 264px;
      margin-right: 24px;
    }

    @media (--only-mobile) {
      width: 240px;
      margin-right: 16px;
    }
  }
`;

export const seedLink = css`
  position: relative;
  width: 270px;
  height: 272px;
  border-radius: 16px;

  @media (--only-desktop) {
    width: 292px;
  }

  @media (--only-tablet) {
    width: 264px;
  }

  @media (--only-mobile) {
    width: 240px;
  }
`;

export const seedImage = css`
  position: absolute;
  top: 0;
  right: 0;
  mix-blend-mode: multiply;
`;

export const seedInfo = css`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;

export const seedItemTerm = css`
  margin-bottom: 4px;
`;

export const seedItemValue = css`
  margin-bottom: 12px;
`;
